const base64ToBlob = (base64) => {
  const MIMEAndCode = base64.split(';base64,'); 
  const contentType = MIMEAndCode[0].split(':')[1]; 

  const rawCode = window.atob(MIMEAndCode[1]);

  // 创建一个Uint8Array数组，长度为解码后字符的长度
  const rawCodeLength = rawCode.length;
  const uInt8Array = new Uint8Array(rawCodeLength);
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < rawCodeLength; i++) {
    uInt8Array[i] = rawCode.charCodeAt(i);
  }
  return new Blob([uInt8Array], {
    type: contentType,
  });
};

export const downloadBase64 = (image, fileName) => {
  const blob = base64ToBlob(image);
  const downloadElement = document.createElement('a');
  const href = window.URL.createObjectURL(blob); // 创建下载的链接
  downloadElement.href = href;
  downloadElement.download = `码单-【${fileName}】.png`;
  document.body.appendChild(downloadElement);
  downloadElement.click(); // 点击下载
  document.body.removeChild(downloadElement); // 下载完成移除元素
  window.URL.revokeObjectURL(href);
};
